export class CommonEntityVO{
    id:string;
    code:string;
    name:string;
    fileName:string;
    nameSpace:string;
    relativePath:string;
    type:string;
    bizobjectID:string;
    uri:string;
    packageName:string;
    packagePath:string;
    local:boolean;
}